import { render, staticRenderFns } from "./tableCustomer.vue?vue&type=template&id=5ecc5230&scoped=true&"
import script from "./tableCustomer.vue?vue&type=script&lang=js&"
export * from "./tableCustomer.vue?vue&type=script&lang=js&"
import style0 from "./tableCustomer.vue?vue&type=style&index=0&id=5ecc5230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc5230",
  null
  
)

export default component.exports